<template>
  <CommunityBanner />
  <CommunityContribute />
  <CommunityReward />
  <CommunityPath />
  <CommunityCore />
  <CommunityCity />
  <CommunityActive />
</template>

<script lang="ts" type="text/tsx">
import CommunityBanner from '@template/page/community/communityBanner.vue';
import CommunityContribute from '@template/page/community/communityContribute.vue';
import CommunityReward from '@template/page/community/communityReward.vue';
import CommunityPath from '@template/page/community/communityPath.vue';
import CommunityCore from '@template/page/community/communityCore.vue';
import CommunityCity from '@template/page/community/communityCity.vue';
import CommunityActive from '@template/page/community/communityActive.vue';

export default {
  name: 'community',
  components: {
    CommunityBanner,
    CommunityContribute,
    CommunityReward,
    CommunityPath,
    CommunityCore,
    CommunityCity,
    CommunityActive
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/community/';
</style>